/**
 * JSON Schema for the main object.
 *
 * http://json-schema.org/
 */
export default {
  id: "/Heartbeat",
  type: "object",
  properties: {
    origin: { type: "string" },
    media_id: { type: "string" },
    playback_time: { type: "string" },
    module_id: { type: "string" },
    page_link: { type: "string" },
    list_name: {
      type: "string",
      enum: ["mystarzlist", "watchlist", "historylist"]
    },
    series_id: { type: "string" },
    season_number: { type: "integer" },
    episode_number: { type: "integer" },
    first_play: { type: "boolean" }
  },
  required: ["origin", "media_id", "playback_time"],
  dependencies: {
    series_id: ["season_number", "episode_number"]
  }
};
